import React from 'react';

import Select from '../../../../common/data-entry/Select';

const PatientStatusSelect = ({ setPatientStatus, requiredField, disabled }) => {
  const onChangeStatus = item => {
    setPatientStatus(item?.name);
  };

  return (
    <Select
      label="Patient Status"
      clearSearchOnSelection
      dataSource={[
        { id: 'PRE-SCREENING', name: 'Pre-screening' },
        { id: 'PRE-SCREENED', name: 'Pre-screened' }
      ]}
      optionLabelKey="name"
      optionValueKey="id"
      onChange={onChangeStatus}
      searchable
      searchPlaceholder="Patient Status"
      clearable={false}
      required={requiredField}
      disabled={disabled}
      validate={false}
      value={{ id: 'IDENTIFIED', name: 'Identified' }}
    />
  );
};

export default PatientStatusSelect;
